module.exports = __webpack_public_path__ + "static/media/recent-three.daf9babc.png";